import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';
import GenericListPair from 'modules/common/components/GenericListPair';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { customStyle } from 'helper';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/hooks/useDebounce';
import BarangayContent from './BarangayContent';
import UpdateModal from '../components/UpdateModal';
import * as actions from '../action';
import * as c from '../constant';

const INIT_FILTER = {
  sort_by: 'desc',
  isPaginate: 1,
  q: '',
  region_code: '',
  province_code: '',
  municipality_code: '',
};

function BarangayContainer({
  match,
  isLoading,
  history,
  getBarangays,
  barangayList,
  barangayListPager,
  getRegionsList,
  getProvinceList,
  getMunicipalityList,
  regionsList,
  municipalityList,
  provinceList,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const INIT_STATE = {
    label: '',
    value: 0,
  };
  const [region, setRegion] = useState(INIT_STATE);
  const [province, setProvince] = useState(INIT_STATE);
  const [municipality, setMunicipality] = useState(INIT_STATE);
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getRegionsList({ per_page: 1000 });
  }, []);

  useEffect(() => {
    getProvinceList({
      per_page: 1000,
      ...(region.value && { region_code: region.value }),
    });
  }, [JSON.stringify(region)]);

  useEffect(() => {
    getMunicipalityList({
      per_page: 1000,
      ...(province.value && { province_code: province.value }),
    });
  }, [JSON.stringify(province)]);

  useEffect(() => {
    getBarangays(debouncedFilter);

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleRegionSelect = (e) => {
    setRegion(e);
    setFilter((prev) => ({
      ...prev,
      q: '',
      province_code: '',
      region_code: e.value,
    }));
    setProvince(INIT_STATE);
  };

  const handleProvinceSelect = (e) => {
    setProvince(e);
    setFilter((prev) => ({
      ...prev,
      q: '',
      municipality_code: '',
      province_code: e.value,
    }));
    setMunicipality(INIT_STATE);
  };

  const handleMunicipalitySelect = (e) => {
    setMunicipality(e);
    setFilter((prev) => ({ ...prev, q: '', municipality_code: e.value }));
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <UpdateModal barangayInfo={data.attributes} selected={data.id} />
      ),
      title: 'Update Barangay',
      modalSize: 'modal-md',
    });
  };

  return (
    <div>
      <div className="card p-0 mb-3 mt-3">
        <div className="container-fluid d-flex px-0">
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select Region:
            </label>
            <div style={{ width: 250 }}>
              <Select
                styles={customStyle}
                placeholder="Select Region"
                value={region}
                options={createDropdown(regionsList)}
                onChange={(e) => {
                  handleRegionSelect(e);
                }}
              />
            </div>
          </div>
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select Province:
            </label>
            <div style={{ width: 250 }}>
              <Select
                value={province}
                styles={customStyle}
                placeholder="Select Province"
                options={createDropdown(provinceList)}
                onChange={(e) => {
                  handleProvinceSelect(e);
                }}
              />
            </div>
          </div>
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select City/Municipality:
            </label>
            <div style={{ width: 250 }}>
              <Select
                options={createDropdown(municipalityList)}
                styles={customStyle}
                placeholder="Select City/Municipality"
                value={municipality}
                onChange={(e) => {
                  handleMunicipalitySelect(e);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <Route
        path={`${match.path}/:barangayId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Barangay List"
            // getData={getBarangays}
            // setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search Barangay..."
            listName="Barangay"
            label="Barangay"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.name')}
                </div>
              </div>
            )}
            isLoading={isLoading}
            selected={params.barangayId}
            data={barangayList}
            dataPager={barangayListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:barangayId?`}
                    render={() => <BarangayContent handleEdit={handleEdit} />}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:barangayId?`}
                  render={() =>
                    !params.barangayId && barangayList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(barangayList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

BarangayContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBarangays: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  barangayListPager: PropTypes.instanceOf(Object).isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: api.loading.indexOf(c.GET_BARANGAYS) > -1,
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  barangayListPager: _.get(api, `${c.GET_BARANGAYS}.pager`) || {},
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BarangayContainer);
